import styled from 'styled-components';
import RcOverflow from 'rc-overflow';

const Root = styled(RcOverflow) `
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
`;

export { Root };
